module.exports = __webpack_public_path__ + "static/8-2a4f21dc0e06ca85edb11269afa61e7d.png";